<script setup>
import { useI18n } from 'vue-i18n';
import SettingsToggleSection from 'dashboard/components-next/Settings/SettingsToggleSection.vue';

// Card de knobs per-cuenta de WhatsApp QR en Settings → Masifi Inbox (grupos F3a; editar / eliminar para todos). Index.vue
// la monta solo con el módulo QR activo y le pasa la sección i18n (MASIFI_SETTINGS.<section>) y los knobs
// [key del REGISTRY, etiqueta, parámetros del texto].
const props = defineProps({
  settings: { type: Object, required: true },
  section: { type: String, required: true },
  knobs: { type: Array, required: true },
});
const emit = defineEmits(['update']);
const { t } = useI18n();

// Texto de la sección o de un knob: MASIFI_SETTINGS.<section>[.<label>].HEADER|DESCRIPTION.
const sectionText = (path, params = {}) =>
  // eslint-disable-next-line @intlify/vue-i18n/no-dynamic-keys -- la card es genérica por sección; una sección o knob sin textos en es y en la caza MasifiSettingsIndex.spec.js ("textos de cada card en es y en")
  t(`MASIFI_SETTINGS.${props.section}.${path}`, params);
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-1">
      <h3 class="text-base font-medium text-n-slate-12">
        {{ sectionText('HEADER') }}
      </h3>
      <p class="text-sm text-n-slate-11">
        {{ sectionText('DESCRIPTION') }}
      </p>
    </div>
    <SettingsToggleSection
      v-for="[key, label, params] in knobs"
      :key="key"
      :model-value="Boolean(settings[key])"
      :header="sectionText(`${label}.HEADER`, params || {})"
      :description="sectionText(`${label}.DESCRIPTION`, params || {})"
      @update:model-value="value => emit('update', key, value)"
    />
  </div>
</template>
